<template lang="pug">
  #app.smallScrollBar
    Banner(:show="showBanner" slotName="slotName" @clickBanner2="clickCookieAccept" @clickBanner="clickBanner")
      template( #slotName)
        .text-white.max-w-828.text-left.text-14.tracking-wide
          | {{$t('__cookiesBanner.__asusCookiesAnalyticsAll')}}
          //- br 
          //- |  and other functions. For detailed information, please visit 
          a.text-main-adaLight(href="https://www.asus.com/tw/Terms_of_Use_Notice_Privacy_Policy/Privacy_Policy" target="_blank")  "{{$t('__cookiesBanner.__asusCookiesAnalyticsAllLink')}}"
    
    Modal.z-600(
        maxWidth="900px"
        padding="0"
        rounded="8"
        :show="showCookieModal" 
        :clickOutSideClose="false"  
        :header="'header'"
        :body="'footerBody'" 
        footer="footer"  
        )
        template(#footerBody)
          TabHorizon.max-w-900(:active.sync="tabIndex" class="lg:min-w-900")
            template(v-slot:tab0)
              .pl-24.pr-48.py-32.text-left 
                
                .mb-40.mt-32
                  .text-20p2r.font-600  {{$t('__cookiesBanner.__asusCookiesNotice')}}
                p
                | {{$t('__cookiesBanner.__asusCookiesNoticeText1')}}
                br
                p.mt-20
                | {{$t('__cookiesBanner.__asusCookiesNoticeText2')}}
                
            template(v-slot:tab1)
              
              .pl-24.pr-48.py-32.text-left 
                .mb-12.text-right
                  .text-main-0.text-18p2r.font-600 {{$t('__cookiesBanner.__alwaysActive')}}
                .mb-40
                  .text-20p2r.font-600 {{$t('__cookiesBanner.__essentialCookies')}}
                p
                | {{$t('__cookiesBanner.__essentialCookiesText1')}}
                br
                p.mt-20
                | {{$t('__cookiesBanner.__essentialCookiesText2')}}
                a.text-main-0( href="https://www.asus.com/tw/Terms_of_Use_Notice_Privacy_Policy/Privacy_Policy" target="_blank")  "{{$t('__cookiesBanner.__essentialCookiesText2Link')}}"

            template(v-slot:tab2)
              .pl-24.pr-48.py-32.text-left 
                .mb-12.flex.justify-end
                  ToggleSwitch.font-600(:checked.sync="checked" id="cookieActive" :label="$t('__cookiesBanner.__active')" :reactWord="$t('__cookiesBanner.__inactive')")
                .mb-40
                  .text-20p2r.font-600 {{$t('__cookiesBanner.__analyticsAndOtherCookies')}}
                  .mt-10.text-grey-77 {{$t('__cookiesBanner.__analyticsTargetingAdvertisingAndVideoEmbeddedCookies')}}
                p
                | {{$t('__cookiesBanner.__analyticsAndOtherCookiesText1')}}
                br
                p.mt-20
                | {{$t('__cookiesBanner.__analyticsAndOtherCookiesText2')}}
                a.text-main-0.ml-5(href="https://www.asus.com/tw/Terms_of_Use_Notice_Privacy_Policy/Privacy_Policy" target="_blank") "{{$t('__cookiesBanner.__asusCookiesAnalyticsAllLink')}}"
        template(#footer)
          .flex.justify-end.py-28.px-48
            Button.mr-10.w-160(:text="$t('__cookiesBanner.__saveSetting')" type="borderSolid"  @buttonClick='modalCookieClose(1)')
            Button.w-160(:text="$t('__cookiesBanner.__allowAll')" type="Send"  @buttonClick='modalCookieClose(0)')
            
    
    router-view(v-if="isRouterAlive")
    
    Alert(
        :show="isShow" 
        :clickOutSideClose="false" 
        :custom_header="'header'"
        :body="'footerBody'" 
        footer="footer")
      template(#footerBody)
        ModalAlert.m-auto.flex.justify-center.max-w-412.min-h-120(:data="modal.data"  :fontSize="modal.fontSize")
      template(#footer)
        .flex.justify-center
          Button.mt-10.w-140(:text="modal.btnConfirm.text"  :icon="modal.btnConfirm.icon" :type="modal.btnConfirm.type"
          v-if="modal.btnConfirm.isShow"  @buttonClick='modal.btnClose.onConfirm')
          Button.mt-10.w-144(:text="modal.btnClose.text"  :icon="modal.btnClose.icon" :type="modal.btnClose.type" 
          v-if="modal.btnClose.isShow" @buttonClick='modal.btnClose.onClose')
    Nps
</template>



<script>
import Alert from '@/components/Alert.vue';
import Nps from '@/components/Nps.vue';
import Banner from '@/components/Banner.vue';
import Button from '@/components/Button.vue';
import ModalAlert from '@/components/ModalAlert.vue';
import Modal from '@/components/Modal.vue';
import TabHorizon from '@/components/TabHorizon.vue';
import ToggleSwitch from '@/components/ToggleSwitch.vue';
import {modalConfigMix,mixinMatomo} from '@/utils/mixin';
import { mapMutations } from 'vuex';
import {  getCookie, setCookie } from './utils/cookies.js';
import { ENV } from '@/enum/global';
import { beforeLoadFu } from '@/api/axios';

export default {
  components: {
    Alert,
    Button,
    ModalAlert,
    Banner,
    Modal,
    TabHorizon,
    ToggleSwitch,
    Nps
  },
  provide(){
    return{ //detail頁面原頁刷新的相關內容
      reload:this.reload
    }
  },
  data() {
    return {
      isShow: false,
      modal:{},
      showBanner: false,
      showCookieModal:false,
      tabIndex : 0,
      checked:false,
      isRouterAlive:true,
      tabsCount: 0,
      reload_type: '',

    };
  },
  // computed: {
    //   ...mapGetters(['getStorageUsed', 'getStorageTotal'])
  // },

  mixins: [modalConfigMix,mixinMatomo],
  created(){
  },
  mounted() {
    // this.tabLoad()
    this.isGetCookie()
  },
  methods: {
    ...mapMutations({
      setModal: 'modal/setShowModal',
      setModalType: 'modal/setType',  // show modal
    }),
    isGetCookie(){   //allow cookie
      let isReadPolicy = getCookie('cpp_isReadCookiePolicyDNT');   // 同意cookie ??
      // console.log('isReadPolicy',isReadPolicy);
      console.log('env', this.$store.state.setting.env,ENV.PRODUCTION)
      // temp for cookie在正式機暫時隱藏
      if(this.$store.state.setting.env === ENV.PRODUCTION){
         console.log = function(){}; //不顯示console
      }
      this.showBanner = (isReadPolicy === '') ? true: false; //是否顯示cookie banner
      if(!this.isShowBanner){
        let isReadPolicyA = getCookie('cpp_isReadCookiePolicyDNTAa') === 'true';
        this.matomoConsentHandle(isReadPolicyA);
      } //end: if 

    },
    modalCookieClose(i){
      if(i){
        this.setCookieBannerInfo('cpp_isReadCookiePolicyDNT',  this.checked ? 'Yes': 'No');
        this.setCookieBannerInfo('cpp_isReadCookiePolicyDNTAa', this.checked ? 'true': 'false');
        this.matomoConsentHandle(this.checked);
      }else{
        this.clickCookieAccept();
      }
      this.showCookieModal = false;
      this.showBanner = false;
    },
    clickCookieAccept(){
      this.setCookieBannerInfo('cpp_isReadCookiePolicyDNT', 'Yes');
      this.setCookieBannerInfo('cpp_isReadCookiePolicyDNTAa', 'true'); 
      this.showBanner = false;
      this.matomoConsentHandle(true);
    },
    setCookieBannerInfo(name, value){
      const expires = 365 * 10; //10 years
      console.log('expires',expires);
      setCookie(name, value, expires);
    },
    closeModal(e = false){ //外面呼叫
      this.setModal(e) 
      this.setModalType({})
      // console.log(this.$store.state.modal.isShow, this.$store.state.modal.modalType)
    },
    clickBanner(){
      this.showCookieModal = true;
    },
    reload(){ //detail頁面原頁刷新的相關內容
      this.isRouterAlive = false;
      this.$nextTick(function () {
      this.isRouterAlive = true;
      });
    }
  },
  watch: {   
    '$store.state.modal.isShow': function(v) {
      console.log(v)
      this.isShow = v
    },
    '$store.state.modal.modalType': function(v) {
      this.modal = this.classification(v)  //from modalConfigMix
    },
    '$store.state.modal.setTabCount': function(v) {
      if( !v){
        // localStorage.setItem('closeNps',true);
      }
    }
  }
};
</script>



